export const GA_TRACKING_ID = 'G-H4F0H4RJ12';

type GtagEvent = {
    action: string;
    category: string;
    label?: string;
    value?: number;
    [key: string]: any;
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: string) => {
    if (typeof window.gtag !== 'undefined') {
        window.gtag('config', GA_TRACKING_ID, {
            page_path: url,
        });
    }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const trackEvent = ({ action, category, label, value, ...rest }: GtagEvent) => {
    if (typeof window.gtag !== 'undefined') {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
            ...rest,
        });
    }
};

// Extend the window object to include the gtag function
declare global {
    interface Window {
        gtag: (...args: any[]) => void;
        dataLayer: any[];
        fbq: (...args: any[]) => void;
    }
}

export const fbTrack = (event: string, options: any = {}) => {
    if (typeof window.fbq !== 'undefined') {
        window.fbq('track', event, options);
    }
};
